/**
 * Shared copy for the in-call "invite by email" row (web + native panels).
 * Both panels mint the same WS grant and render the same delivery outcome,
 * so the wording and the email-shape rule live in exactly one place.
 */
export const INVITE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isInviteEmailCandidate(value) {
    const trimmed = value.trim();
    return trimmed.length <= 254 && INVITE_EMAIL_PATTERN.test(trimmed);
}
export function describeInviteEmailOutcome(outcome) {
    if (outcome.status === 'sent') {
        return `Invitation sent to ${outcome.email || 'your guest'}.`;
    }
    switch (outcome.errorCode) {
        case 'VRI_INVITE_EMAIL_RATE_LIMITED':
            return 'Hourly invite limit reached. Try again later.';
        case 'VRI_INVITE_EMAIL_TENANT_DISABLED':
        case 'VRI_INVITE_EMAIL_POLICY_DISABLED':
            return 'Email invitations are not enabled for this deployment.';
        case 'EMAIL_NOT_CONFIGURED':
            return 'Email is not configured for this deployment.';
        case 'INVALID_GUEST_EMAIL':
            return 'Enter a valid email address.';
        default:
            return 'The invitation could not be sent. Try again.';
    }
}
